export default __webpack_public_path__ + "static/media/colin_take_the_sunrise.e52df888.jpg";